<template>
  <section
    id="power-saving"
    class="fluent-free-time"
    :class="lang === 'zh' ? 'fluent-free-time-small' : ''"
    :style="{ height: lang === 'zh' ? `${415 - (50 - fluentFreeTimeStickyOffset * 100) * 2}vh` : '' }"
  >
    <div
      class="free-time-background"
      :style="{ background: `rgb(${backgroundColor}, ${backgroundColor}, ${backgroundColor})` }"
    ></div>
    <div
      ref="sticky"
      class="fluent-free-time-sticky"
      :style="{ height: fluentFreeTimeStickyOffset * 100 + 100 + 'vh' }"
    >
      <div ref="textIntro" class="text-intro free-time-text-intro free-time-top-text-intro">
        <p class="title" :class="topTextEnterScrollMagic ? 'textInPartMotion' : 'visibility-hidden'">
          {{ $t('free-time-title') }}
        </p>
        <p class="description" :class="topTextEnterScrollMagic ? 'textInPartMotion' : 'visibility-hidden'">
          {{ $t('free-time-description') }}
        </p>
      </div>
      <div
        class="free-time-phone-container"
        :class="topTextEnterScrollMagic ? 'textInPartMotion' : 'visibility-hidden'"
        :style="{
          transform: `translate3d(${findx2TranslateX}px, ${findx2TranslateY}px, 0)`,
          transition: findx2TranslateX ? 'none' : undefined
        }"
      >
        <div class="free-time-phone-swipe-container">
          <img
            ref="phone"
            v-lazy="require('../../assets/fluent/phone-model.png')"
            alt="ColorOS 11"
            class="free-time-phone-model"
          />
          <lazy-component
            ref="power5Percentage"
            class="free-time-phone-lazy"
            :class="phoneSwipeIndex >= 1 ? 'free-time-phone-swipe__active' : ''"
          >
            <video muted="muted" preload="metadata" class="free-time-phone-swipe">
              <source
                :src="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}fluent/power-5-percentage.mp4`)"
                type="video/mp4"
              />
            </video>
          </lazy-component>
          <img
            v-for="i in 5"
            :key="i"
            ref="phone"
            v-lazy="require(`../../assets/${lang === 'zh' ? 'zh/' : ''}fluent/power-phone-${i - 1}.jpg`)"
            alt="ColorOS 11"
            class="free-time-phone-swipe"
            :class="phoneSwipeIndex === i - 1 ? 'free-time-phone-swipe__active' : ''"
          />
          <frames-animation
            v-if="lang !== 'zh'"
            ref="power100Percentage"
            class="free-time-phone-swipe"
            :url-context-fn="require.context('../../assets/fluent/power-100-frames', false, /^\.\/.*$/, 'lazy-once')"
            :amount="268"
            :duration="6000"
            :can-webp="true"
            :class="phoneSwipeIndex === 5 ? 'free-time-phone-swipe__active' : ''"
          />
        </div>
        <ul class="free-time-garbage-list" :class="hideGarbageList ? 'free-time__hide' : ''">
          <li
            v-for="(garbage, index) in garbageList"
            :key="index"
            class="free-time-garbage"
            :class="{ keyVisionMotionGarbage: showGarbage }"
            :style="{
              opacity: garbage.progress >= 0.99 ? garbage.opacity : undefined,
              transform: garbage.progress >= 0.99 ? garbage.translate3d : undefined,
              animationDuration: progress >= 0.1 ? '0s' : undefined,
              animationDelay: progress >= 0.1 ? '0s' : undefined
            }"
          >
            <div
              class="free-time-garbage-mask"
              :style="`transform: translate3d(${-100 + 100 * Math.min(0.99, garbage.progress)}%, 0px, 0px);`"
            ></div>
            <img src="../../assets/fluent/free-time-garbage-icon.png" alt="ColorOS 11" class="garbage-left-icon" />
            <div class="garbage-middle-text">
              <div class="garbage-middle-text-title">{{ $t(`free-time-garbage-title-${index}`) }}</div>
              <div class="garbage-middle-text-sub-title">{{ $t(`free-time-garbage-size-${index}`) }}</div>
            </div>
            <img
              v-if="garbage.progress > 0 && garbage.progress <= 0.99"
              src="../../assets/fluent/free-time-garbage-loading.png"
              alt="ColorOS 11"
              class="garbage-right-icon"
            />
          </li>
        </ul>
        <img
          ref="phoneDataLine"
          v-lazy="require('../../assets/fluent/usb-line.png')"
          alt="ColorOS 11"
          class="free-time-usb-line-img"
          :class="topTextEnterScrollMagic ? 'textInPartMotion' : 'visibility-hidden'"
          :style="{
            transform: `translate3d(0, ${-usbTranslateY}px, 0)`,
            transitionDuration: usbTransition ? undefined : '0s'
          }"
        />
      </div>
      <div
        class="text-intro free-time-text-intro power-saving-text-intro"
        :class="hidePowerIntro ? 'free-time__hide' : ''"
        :style="{
          transform: `translate3d(0, ${powerTextTranslateY}px, 0)`
        }"
      >
        <p class="title" :class="{ keyVisionMotionGarbage: showPoverSavingText }">{{ $t('power-saving-title') }}</p>
        <p class="sub-title" :class="{ keyVisionMotionGarbage: showPoverSavingText }">
          {{ $t('power-saving-sub-title') }}
        </p>
        <p class="description" :class="{ keyVisionMotionGarbage: showPoverSavingText }">
          {{ $t('power-saving-description') }}
        </p>
      </div>

      <div
        class="text-intro free-time-text-intro power-saving-text-intro safe-saving-text-intro"
        :class="inNightModeColor ? '' : 'safe-saving-text-day'"
        :style="{
          transform: `translate3d(0, ${safeTextTranslateY}px, 0)`
        }"
      >
        <p class="title" :class="{ keyVisionMotionGarbage: showNightSafeText }">{{ $t('night-safe-title') }}</p>
        <p class="sub-title" :class="{ keyVisionMotionGarbage: showNightSafeText }">
          {{ $t('night-safe-sub-title') }}
        </p>
        <p class="description" :class="{ keyVisionMotionGarbage: showNightSafeText }">
          {{ $t('night-safe-description') }}
        </p>
      </div>
    </div>
  </section>
</template>
<script>
import ScrollMagic from 'scrollmagic';
import FramesAnimation from '@/components/FramesAnimation';
import Controller from '../../util/scrollMagic';
import UpdateAnimationMixin from '../../mixins/updateAnimation';

let SUM_PROGRESS = 2.125 + 4.75;
let GARBAGE_START_PROGRESS = 0.125 / SUM_PROGRESS;
let GARBAGE_START_TRANS = 1.125 / SUM_PROGRESS;
let GARBAGE_START_SAVING = 2.125 / SUM_PROGRESS;
const GARBAGE_START_POWER_TEXT = (2.215 + 0.75) / SUM_PROGRESS;
const GARBAGE_STOP_POWER_TEXT = (2.215 + 0.75 + 0.25) / SUM_PROGRESS;
const GARBAGE_START2_POWER_TEXT = (2.215 + 1.75) / SUM_PROGRESS;
const GARBAGE_START_SAFE_TEXT = (2.215 + 2.1) / SUM_PROGRESS;
const GARBAGE_STOP_SAFE_TEXT = (2.215 + 2.75) / SUM_PROGRESS;
const GARBAGE_START2_SAFE_TEXT = (2.215 + 3.75) / SUM_PROGRESS;
const GARBAGE_END_BACKGROUND = (2.215 + 3.75 + 0.5) / SUM_PROGRESS;
let safeTextShowOnce = false;

export default {
  components: {
    FramesAnimation
  },
  mixins: [UpdateAnimationMixin],
  inject: ['lang'],
  data() {
    if (this.lang === 'zh') {
      SUM_PROGRESS = 2.625;
      GARBAGE_START_PROGRESS = 0.01 / SUM_PROGRESS;
      GARBAGE_START_TRANS = 1.125 / SUM_PROGRESS;
      GARBAGE_START_SAVING = 2.125 / SUM_PROGRESS;
    }
    return {
      progress: 0,
      endProgress: 0,
      phoneSwipeDistance: 0,
      usbTransition: true,
      findx2MoreToCenterDistance: 0,
      findx2TranslateX: 0,
      findx2TranslateY: 0,
      usbTranslateY: 0,
      hideGarbageList: false,
      phoneSwipeIndex: 0,
      showGarbage: false,
      garbageList: [
        {
          progress: 0,
          translate3d: 'translate3d(0, 0, 0)',
          opacity: 1
        },
        {
          progress: 0,
          translate3d: 'translate3d(0, 0, 0)',
          opacity: 1
        },
        {
          progress: 0,
          translate3d: 'translate3d(0, 0, 0)',
          opacity: 1
        },
        {
          progress: 0,
          translate3d: 'translate3d(0, 0, 0)',
          opacity: 1
        }
      ],
      hidePowerIntro: false,
      showPoverSavingText: false,
      powerTextTranslateY: 0,

      showNightSafeText: false,
      safeTextTranslateY: 0,

      // 背景 字符串的形式，响应式效果不好，经常会漏比如 rgb(15, 15, 15) 无法切到 rgb(0, 0, 0)
      // backgroundColor: this.lang === 'zh' ? 'rgb(7, 11, 13)' : 'rgb(0, 0, 0)',
      backgroundColor: this.lang === 'zh' ? 11 : 0,
      inNightModeColor: true,
      topTextEnterProtect: 0,
      topTextEnterScrollMagic: false,
      fluentFreeTimeStickyOffset: 0.5
    };
  },
  watch: {
    progress(value) {
      const innerHeight = window.innerHeight;
      const oldPhoneSwipeIndex = this.phoneSwipeIndex;
      this.usbTransition = true;
      // 0.05 数据线上滑
      // 0.125 出现垃圾清理
      // 0.125 + 1 结束垃圾进度，进度每个240
      // 0.125 + 1 + 1 结束飞出，飞出每个240
      // 2.125 +
      // 充电手机切换
      if (value < GARBAGE_START_PROGRESS) {
        this.phoneSwipeIndex = 0;
      } else if (value >= GARBAGE_START_PROGRESS && value < GARBAGE_START_SAVING) {
        this.phoneSwipeIndex = 1;
      }
      // 闲时修复
      this.hideGarbageList = value > GARBAGE_START_PROGRESS ? false : this.showGarbage ? true : false;
      if (value <= GARBAGE_START_PROGRESS / 2 && this.hideGarbageList) {
        this.showGarbage = false;
      } else if (value <= GARBAGE_START_PROGRESS) {
        this.showGarbage = this.hideGarbageList ? true : false;
      } else if (value > GARBAGE_START_PROGRESS) {
        this.showGarbage = true;
      }
      // 闲时修复手机内的处理项
      if (value <= GARBAGE_START_PROGRESS) {
        // 开始闲时修复
        this.garbageList.forEach(item => {
          item.progress = 0;
          item.opacity = 1;
          item.translate3d = 'translate3d(0, 0, 0)';
        });
      } else {
        // 闲时修复,手机画面
        const newValue = value <= GARBAGE_START_SAVING ? value : GARBAGE_START_SAVING;
        this.garbageList.forEach((item, index) => {
          item.progress = Math.min(1, Math.max(0, (newValue - GARBAGE_START_PROGRESS) / (0.25 / SUM_PROGRESS) - index));
          const transRate = Math.min(1, Math.max(0, (newValue - GARBAGE_START_TRANS) / (0.25 / SUM_PROGRESS) - index));
          item.opacity = newValue <= GARBAGE_START_TRANS ? 1 : 1 - transRate;
          item.translate3d =
            newValue <= GARBAGE_START_TRANS ? 'translate3d(0, 0, 0)' : `translate3d(${-418 * transRate}px, 0, 0)`;
        });
      }
      // 中文特殊处理 最后 return 就好了
      if (this.lang === 'zh') {
        this.findx2TranslateY = 0;
        if (value === 1) {
          this.phoneSwipeIndex = 2;
        }
        if (value < GARBAGE_START_PROGRESS) {
          this.usbTranslateY = 0;
        } else if (value >= GARBAGE_START_SAVING) {
          this.usbTranslateY = -300;
        } else {
          this.usbTranslateY = 90;
        }
        if (value >= GARBAGE_START_SAVING) {
          this.findx2TranslateY =
            (this.findx2MoreToCenterDistance * (value - GARBAGE_START_SAVING)) / (0.5 / SUM_PROGRESS);
        }
        this.playFreeTime5PercentVideo(oldPhoneSwipeIndex);
        return;
      }

      // 超级省电 手机模型移动
      if (value >= GARBAGE_START_SAVING) {
        // 手机下移动, GARBAGE_START_SAVING 开始
        // 50vh y:240 数据线随着滚动下滑
        // 50vh y:0 x: 360
        // 75vh 0  100vh y:-190 数据线随着滚动上滑
        const maxTransX = window.innerWidth > 1440 ? 360 : window.innerWidth * 0.25;
        if (value <= GARBAGE_START_SAVING + 0.5 / SUM_PROGRESS) {
          this.findx2TranslateY =
            (this.findx2MoreToCenterDistance * (value - GARBAGE_START_SAVING)) / (0.5 / SUM_PROGRESS);
          this.findx2TranslateX = 0;
          this.usbTranslateY = 90 + -SUM_PROGRESS * innerHeight * (value - GARBAGE_START_SAVING);
          this.usbTransition = false;
          this.phoneSwipeIndex = 2;
        } else if (value <= GARBAGE_START_SAVING + 1 / SUM_PROGRESS) {
          this.findx2TranslateY = this.findx2MoreToCenterDistance;
          this.findx2TranslateX =
            (maxTransX * (value - GARBAGE_START_SAVING - 0.5 / SUM_PROGRESS)) / (0.5 / SUM_PROGRESS);
          // this.usbTranslateY = 90 - 0.5 * innerHeight;
          this.usbTranslateY = 90 - 1 * innerHeight;
          this.usbTransition = false;
          this.phoneSwipeIndex = 3;
        } else if (value <= GARBAGE_START_SAVING + 1.75 / SUM_PROGRESS) {
          this.findx2TranslateY = this.findx2MoreToCenterDistance;
          this.findx2TranslateX = maxTransX;
          // this.usbTranslateY = 90 - 0.5 * innerHeight;
          this.usbTranslateY = 90 - 1 * innerHeight;
          this.phoneSwipeIndex = 4;
        } else if (value <= GARBAGE_START_SAVING + 2.75 / SUM_PROGRESS) {
          this.findx2TranslateY =
            this.findx2MoreToCenterDistance -
            ((this.findx2MoreToCenterDistance * (value - GARBAGE_START_SAVING - 1.75 / SUM_PROGRESS)) /
              (1 / SUM_PROGRESS)) *
              0.8;
          this.findx2TranslateX = maxTransX;

          this.usbTranslateY =
            90 -
            0.5 * innerHeight +
            (SUM_PROGRESS * innerHeight * (value - GARBAGE_START_SAVING - 1.75 / SUM_PROGRESS)) / 2;
          this.usbTransition = false;
          this.phoneSwipeIndex = 4;
        } else {
          this.findx2TranslateY = 0.2 * this.findx2MoreToCenterDistance;
          this.findx2TranslateX = maxTransX;
          this.usbTranslateY = 90;
          this.phoneSwipeIndex = 5;
          this.usbTransition = false;
          if (value < GARBAGE_END_BACKGROUND && this.usbTranslateY > 80) this.playFreeTime100Percent(value);
        }
      } else {
        this.findx2TranslateY = 0;
        this.findx2TranslateX = 0;
        if (value < 0.02) {
          this.usbTranslateY = 0;
        } else {
          this.usbTranslateY = 90;
        }
      }

      if (value >= GARBAGE_END_BACKGROUND) {
        // this.usbTranslateY = -200;
        this.usbTranslateY = ((value - GARBAGE_END_BACKGROUND) / (1 - GARBAGE_END_BACKGROUND)) * -290 + 90;
        this.usbTransition = false;
        this.playFreeTime100Percent(1);
      }
      // 超级省电文案
      this.hidePowerIntro = value > GARBAGE_START_POWER_TEXT ? false : this.showPoverSavingText ? true : false;
      if (value <= GARBAGE_START_POWER_TEXT - 0.02 && this.hidePowerIntro) {
        this.showPoverSavingText = false;
      } else if (value <= GARBAGE_START_POWER_TEXT) {
        this.showPoverSavingText = this.hideGarbageList ? true : false;
      } else if (value > GARBAGE_START_POWER_TEXT) {
        this.showPoverSavingText = true;
      }
      if (value >= GARBAGE_START_POWER_TEXT && value < GARBAGE_STOP_POWER_TEXT) {
        this.powerTextTranslateY = -SUM_PROGRESS * innerHeight * (value - GARBAGE_START_POWER_TEXT);
      } else if (value >= GARBAGE_STOP_POWER_TEXT && value < GARBAGE_START2_POWER_TEXT) {
        this.powerTextTranslateY = -SUM_PROGRESS * innerHeight * (GARBAGE_STOP_POWER_TEXT - GARBAGE_START_POWER_TEXT);
      } else if (value >= GARBAGE_START2_POWER_TEXT) {
        this.powerTextTranslateY =
          -SUM_PROGRESS *
          innerHeight *
          (value - GARBAGE_START2_POWER_TEXT + GARBAGE_STOP_POWER_TEXT - GARBAGE_START_POWER_TEXT);
      } else {
        this.powerTextTranslateY = 0;
      }

      // 充电保护
      if (value <= GARBAGE_STOP_SAFE_TEXT) {
        this.showNightSafeText = safeTextShowOnce ? true : false;
      } else if (value > GARBAGE_STOP_SAFE_TEXT) {
        this.showNightSafeText = true;
        safeTextShowOnce = true;
      }
      if (value >= GARBAGE_START_SAFE_TEXT && value < GARBAGE_STOP_SAFE_TEXT) {
        this.safeTextTranslateY = -SUM_PROGRESS * innerHeight * (value - GARBAGE_START_SAFE_TEXT);
      } else if (value >= GARBAGE_STOP_SAFE_TEXT && value < GARBAGE_START2_SAFE_TEXT) {
        this.safeTextTranslateY = -SUM_PROGRESS * innerHeight * (GARBAGE_STOP_SAFE_TEXT - GARBAGE_START_SAFE_TEXT);
      } else if (value >= GARBAGE_START2_SAFE_TEXT) {
        this.safeTextTranslateY = -SUM_PROGRESS * innerHeight * (GARBAGE_STOP_SAFE_TEXT - GARBAGE_START_SAFE_TEXT);
      } else {
        this.safeTextTranslateY = 0;
      }
      // 充电保护文案颜色切换
      if (this.inNightModeColor && value >= GARBAGE_END_BACKGROUND) {
        this.inNightModeColor = false;
      } else if (!this.inNightModeColor && value <= GARBAGE_START2_SAFE_TEXT) {
        this.inNightModeColor = true;
      }

      // 最后一屏背景和文字处理
      if (value <= GARBAGE_START2_SAFE_TEXT) {
        this.backgroundColor = 0;
      } else if (value > GARBAGE_START2_SAFE_TEXT && value <= GARBAGE_END_BACKGROUND) {
        const color = Math.floor(
          (255 * (value - GARBAGE_START2_SAFE_TEXT)) / (GARBAGE_END_BACKGROUND - GARBAGE_START2_SAFE_TEXT)
        );
        this.backgroundColor = color;
      } else {
        this.backgroundColor = 255;
        // this.phoneSwipeIndex = 6;
        // this.$refs.power100Percentage.play();
      }

      // 视频处理 power5Percentage
      this.playFreeTime5PercentVideo(oldPhoneSwipeIndex);
    }
  },
  mounted() {
    const isOversea = this.lang !== 'zh';
    this.getSwipeDistance();
    const topScene = new ScrollMagic.Scene({
      triggerElement: '.fluent-free-time',
      triggerHook: isOversea ? 0 : 0.5
    })
      .addTo(Controller)
      .on('progress', () => {
        this.topTextEnterScrollMagic = true;
      });
    setTimeout(() => {
      if (topScene.progress() > 0) {
        this.topTextEnterScrollMagic = true;
      }
    }, 1000);

    this.scene = new ScrollMagic.Scene({
      duration: (SUM_PROGRESS - (0.5 - this.fluentFreeTimeStickyOffset)) * window.innerHeight,
      triggerElement: '.fluent-free-time',
      offset: this.fluentFreeTimeStickyOffset * window.innerHeight,
      triggerHook: 0
    })
      .setPin('.fluent-free-time-sticky')
      .addTo(Controller)
      .on('progress', e => {
        if (Math.abs(this.progress - e.progress) > 0.3) {
          this.progress = e.progress;
        } else {
          this.updateBezier('progress', e.progress, 300);
        }
      })
      .on('enter', () => {
        if (this.$refs.textIntro && this.$refs.sticky) {
          this.setFindx2MoreToCenterDistance();
        }
      });
    this.scene.progress(0);

    if (isOversea && window.innerWidth > 734) {
      new ScrollMagic.Scene({
        duration: SUM_PROGRESS * window.innerHeight + 6 * window.innerHeight,
        triggerElement: '.fluent-free-time',
        offset: -2 * window.innerHeight,
        triggerHook: 0
      })
        .addTo(Controller)
        .on('enter', () => {
          if (this.$refs.power100Percentage) {
            this.$refs.power100Percentage.load();
          }
        });
    }

    window.addEventListener('resize', this.getSwipeDistance);
  },
  destroyed() {
    window.removeEventListener('resize', this.getSwipeDistance);
  },
  methods: {
    setFindx2MoreToCenterDistance() {
      const stickyRect = this.$refs.sticky.getBoundingClientRect();
      const textRect = this.$refs.textIntro.getBoundingClientRect();
      const initStickyDelta = (this.fluentFreeTimeStickyOffset + 1) * window.innerHeight;
      const textDelta = textRect.height < 70 ? 80 - textRect.height : 0;
      this.findx2MoreToCenterDistance =
        (textRect.top - stickyRect.top || 140) +
        0.125 * window.innerHeight -
        (stickyRect.height - initStickyDelta + textDelta) / 2;
    },
    getSwipeDistance() {
      const startBottom = 126 + (this.$refs.phone.clientWidth * 954) / 434;
      const dataLineHight = (this.$refs.phoneDataLine.clientWidth * 250) / 44;
      const targetBottom = Math.max(
        100,
        window.innerHeight - (window.innerHeight < 400 ? dataLineHight / 2 : dataLineHight)
      );
      this.phoneSwipeDistance = targetBottom - startBottom + 2;

      this.setFindx2MoreToCenterDistance();

      this.fluentFreeTimeStickyOffset = window.innerHeight > 1000 ? Math.max(0.1, 1.5 - window.innerHeight / 960) : 0.5;
      if (this.scene) {
        this.scene
          .offset(this.fluentFreeTimeStickyOffset * window.innerHeight)
          .duration((SUM_PROGRESS - (0.5 - this.fluentFreeTimeStickyOffset)) * window.innerHeight);
      }
    },
    // 前面 5% 充电视频
    playFreeTime5PercentVideo(oldPhoneSwipeIndex) {
      const power5Percentage =
        this.$refs.power5Percentage && this.$refs.power5Percentage.$el && this.$refs.power5Percentage.$el.children[0];
      if (power5Percentage) {
        if (oldPhoneSwipeIndex === 0 && this.phoneSwipeIndex === 1) {
          power5Percentage.currentTime = 0;
          if (this.power5PercentageTimer) clearTimeout(this.power5PercentageTimer);
          this.power5PercentageTimer = setTimeout(() => {
            power5Percentage.play();
          }, 300);
        } else if (oldPhoneSwipeIndex > 1 && this.phoneSwipeIndex === 1) {
          if (power5Percentage.duration) {
            power5Percentage.currentTime = power5Percentage.duration;
            power5Percentage.pause();
          }
        } else if (oldPhoneSwipeIndex === 1 && this.phoneSwipeIndex === 0) {
          power5Percentage.currentTime = 0;
          power5Percentage.pause();
        }
      }
    },
    // 前面 5% - 100% 充电序列帧动画
    playFreeTime100Percent(value) {
      const frameProgress =
        (value - (GARBAGE_START_SAVING + 2.75 / SUM_PROGRESS)) /
        (GARBAGE_END_BACKGROUND - (GARBAGE_START_SAVING + 2.75 / SUM_PROGRESS));

      this.$refs.power100Percentage.drawFrame(Math.min(268, Math.ceil(frameProgress * 268)));
    }
  }
};
</script>
